export default __webpack_public_path__ + "static/media/piggy-bank.d587c8b0.png";